import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Generator from "@/pages/Generator";
import Library from "@/pages/Library";
import Dashboard from "@/pages/Dashboard";
import Operations from "@/pages/Operations";
import Settings from "@/pages/Settings";
import OperatorDashboard from "@/pages/OperatorDashboard";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Nav />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/generator" element={<Generator />} />
                    <Route path="/library" element={<Library />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/operations" element={<Operations />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/operator" element={<OperatorDashboard />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
